import type { MoveTaskTrackerColumnsItem } from '../store/taskTracker.types'

export type TaskTrackerBoardLaneItemType = 'column' | 'summary'

export type TaskTrackerBoardLaneItem = {
  id: number
  type: TaskTrackerBoardLaneItemType
}

export const buildTaskTrackerBoardMoveItems = (
  items: TaskTrackerBoardLaneItem[],
): MoveTaskTrackerColumnsItem[] =>
  items.map((item, index) => ({
    id: item.id,
    type: item.type,
    position: index + 1,
  }))

export const buildTaskTrackerColumnMoveItems = (
  orderedColumnIds: number[],
): MoveTaskTrackerColumnsItem[] =>
  buildTaskTrackerBoardMoveItems(
    orderedColumnIds.map((id) => ({ id, type: 'column' })),
  )
